import { SVGProps } from 'react';

const Health = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M6.264 3.518a5.751 5.751 0 0 1 5.747 1.366 5.748 5.748 0 0 1 5.735-1.341 5.748 5.748 0 0 1 2.284 9.575c-.017.017-.036.032-.054.047l-7.44 7.368a.75.75 0 0 1-1.056 0L3.984 13.11a5.746 5.746 0 0 1 2.28-9.592Zm2.184 1.256a4.251 4.251 0 0 0-4.296 2.417 4.246 4.246 0 0 0 .73 4.692l.153.157.005.004 6.968 6.9 6.969-6.9c.012-.013.026-.024.039-.035a4.244 4.244 0 0 0 1.232-3.11 4.246 4.246 0 0 0-6.336-3.577 4.249 4.249 0 0 0-1.305 1.145.75.75 0 0 1-1.2-.003 4.248 4.248 0 0 0-2.959-1.69Zm2.802 9.449v-1.917H9.3a.75.75 0 0 1 0-1.5h1.95V8.889a.75.75 0 0 1 1.5 0v1.917h1.95a.75.75 0 0 1 0 1.5h-1.95v1.917a.75.75 0 0 1-1.5 0Z"
    />
  </svg>
);

export default Health;
